import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a3f25c9c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f25c9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3f25c9c')) {
      api.createRecord('a3f25c9c', component.options)
    } else {
      api.reload('a3f25c9c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a3f25c9c&scoped=true&", function () {
      api.rerender('a3f25c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2haB0fdQBaF5U/JS/comp/SearchFilterTokens.vue"
export default component.exports